import axios from "axios";
import createAuthRefreshInterceptor from "axios-auth-refresh";
import store from "../store";
import { logout, setAuthTokens } from "../store/slices/auth";

const axiosService = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

axiosService.interceptors.request.use(async (config) => {
    const { token } = store.getState().auth;

    // console.debug("[Interceptor] Current token:", token);

    if (token) {
        config.headers.Authorization = "Bearer " + token;
    }
    return config;
});

axiosService.interceptors.response.use(
    (res) => {
        return Promise.resolve(res);
    },
    (err) => {
        console.debug("[Response]", err.config.url, err.response.status, err.response.data);
        return Promise.reject(err);
    }
);

// @ts-ignore
const refreshAuthLogic = async (failedRequest: any) => {
    const { refreshToken } = store.getState().auth;

    if (refreshToken === null) {
        store.dispatch(logout());
        window.location.href = "/login";
        return Promise.reject("No refresh token available");
    }

    try {
        const response = await axios.post("/auth/refresh/", { refresh: refreshToken }, { baseURL: process.env.REACT_APP_API_URL });

        const { access, refresh } = response.data.body;

        store.dispatch(
            setAuthTokens({
                token: access,
                refreshToken: refresh,
            })
        );
        failedRequest.response.config.headers.Authorization = "Bearer " + access;

        return Promise.resolve();
    } catch (error) {
        store.dispatch(logout());
        window.location.href = "/login";
        return Promise.reject(error);
    }
};

createAuthRefreshInterceptor(axiosService, refreshAuthLogic);

export function fetcher<T = any>(url: string) {
    return axiosService.get<T>(url).then((res) => res.data);
}

export default axiosService;
